import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { AuthenticationGuard } from '../../shared/guard/authentication-guard';
import { ModuleRedirectGuard } from '../../shared/guard/module-redirect-guard';

const routes: Routes = [
  {
    path: 'Crm',
    pathMatch: 'full',
    canActivate: [AuthenticationGuard, ModuleRedirectGuard],
    data: { moduleRedirect: 'crm' },
    children: [],
  },
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
})
export class CrmRoutingModule {}
